/* eslint-disable no-script-url, no-underscore-dangle */
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { externalScriptPromise } from 'utils/helpers';

const propTypes = {
  identifier: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
};

class LiveagentButton extends Component {
  componentDidMount() {
    const liveagentPromise = externalScriptPromise(
      'https://c.la1-c2-lon.salesforceliveagent.com/content/g/js/43.0/deployment.js',
      'liveagent'
    );

    liveagentPromise.then(() => {
      if (window.liveagent) {
        window.liveagent.init('https://d.la1-c2-lon.salesforceliveagent.com/chat', '572D0000000TOWG', '00DD0000000plZX');
        if (!window._laq) {
          window._laq = [];
        }
        window._laq.push(() => {
          window.liveagent.showWhenOnline('573D0000000TOXx', document.getElementById('liveagent_button_online_573D0000000TOXx'));
          window.liveagent.showWhenOffline('573D0000000TOXx', document.getElementById('liveagent_button_offline_573D0000000TOXx'));

          const { identifier, firstName, lastName } = this.props;
          window.liveagent.addCustomDetail('ContactSSN', identifier, true);
          window.liveagent.setName(`${firstName} ${lastName}`);
          window.liveagent.findOrCreate('Account').map('SSN__c', 'ContactSSN', true, true, true);
          window.liveagent.findOrCreate('Account').saveToTranscript('Account');
        });
      }
    });
  }

  render() {
    return (
      <div className="liveagent">
        <div className="container">
          <a
            className="liveagent__btn"
            id="liveagent_button_online_573D0000000TOXx"
            // eslint-disable-next-line react/jsx-no-script-url -- node upgrade
            href="javascript://Chat"
            style={{ display: 'none' }}
            onClick={() => window.liveagent.startChat('573D0000000TOXx')}
          >
            <span className="icon icon--chat" />
            <span className="liveagent__btn-title">
              <FormattedMessage id="liveagent.online" />
            </span>
          </a>
          <div
            className="liveagent__btn liveagent__btn--offline"
            id="liveagent_button_offline_573D0000000TOXx"
            style={{ display: 'none' }}
          >
            <span className="icon icon--chat-offline" />
            <span className="liveagent-btn__title">
              <FormattedMessage id="liveagent.offline" />
            </span>
          </div>
        </div>
      </div>
    );
  }
}

LiveagentButton.propTypes = propTypes;
export default LiveagentButton;
